import { LocationChip } from './location';

export const Chips = {
  LocationChip,
};
